import { Feature } from '@tencent/workbench';
import { config } from './config';
import type { INoteSwitchFeature } from './note-switch-interface';
import { BaseCheckFeature } from '../../common/feature/base-check-feature';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TOOLBAR_REPORT_MAP } from '@src/framework/workbench/middleware/report';

@Feature()
export class NoteSwitchFeature extends BaseCheckFeature implements INoteSwitchFeature {
    public id = config.id;
    public config = config;

    public onClick() {
        if (this.isNoteShow) {
            this.getNoteAreaManager().setHide();
        } else {
            this.getNoteAreaManager().setShow();
        }
        this.toolbarService.$forceUpdate();
        this.report();
    }

    public shouldCheck(): boolean {
        return this.buttonChecked;
    }

    protected isDisplayed(): boolean {
        return this.isNoteShow;
    }

    protected getCustomDisabledState(): boolean {
        return !!(this.getMasterLayoutEditService()?.isMasterEditType);
    }

    private get isNoteShow(): boolean {
        return this.getNoteAreaManager().show;
    }

    private getNoteAreaManager() {
        return this.getAppService().viewableServiceLayer.noteAreaManager;
    }

    private report() {
        tdw({
            ...TOOLBAR_REPORT_MAP[this.config.id](),
            ver5: this.buttonChecked ? 1 : 0,
        });
    }
}
